import { render } from "./MContextMenu.vue?vue&type=template&id=c8cfdd0a"
import script from "./MContextMenu.vue?vue&type=script&lang=js"
export * from "./MContextMenu.vue?vue&type=script&lang=js"

import "./MContextMenu.vue?vue&type=style&index=0&id=c8cfdd0a&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__